import { KARAOKE_COMPOSITION_NAME } from "./types/constants";
import type { TablesInsert } from "./types/database.types";

export const DEV_USER_FREE = {
  id: "036b762c-f547-48ee-b293-cd44230e231c",
  email: "free@mykaraoke.video",
  password: "MyKaraoke-Dev-Seed-2026!",
  full_name: "Free User",
};

export const DEV_USER_STANDARD = {
  id: "76d40d3b-4b6c-45ec-8e9f-de80833e1c3e",
  email: "standard@mykaraoke.video",
  password: "MyKaraoke-Dev-Seed-2026!",
  full_name: "Standard User",
  customer_id: "cus_TbOJLniaypOpHv",
};

export const DEV_USER_PREMIUM = {
  id: "37caf97c-bae8-4621-8ac9-66cdb9103546",
  email: "premium@mykaraoke.video",
  password: "MyKaraoke-Dev-Seed-2026!",
  full_name: "Premium User",
  customer_id: "cus_SIb6zEdjdgvTuC",
};

const DEV_PROJECT_ID = "f7a30e62-edfb-4ce2-9bed-f2c2b13e1e35";

export const DEV_PROJECT: TablesInsert<"projects"> = {
  id: DEV_PROJECT_ID,
  user_id: DEV_USER_PREMIUM.id,
  title: "It's My Life",
  duration_in_seconds: 225,
  original_url:
    "https://media.mkv.so/usr_37caf97c-bae8-4621-8ac9-66cdb9103546/prj_f7a30e62-edfb-4ce2-9bed-f2c2b13e1e35/Vn1WmbOTDHL52jRI.mp3.m4a",
  instrumental_url:
    "https://media.mkv.so/usr_37caf97c-bae8-4621-8ac9-66cdb9103546/prj_f7a30e62-edfb-4ce2-9bed-f2c2b13e1e35/pVWfWKi89xTWagVc.mp3.m4a",
  vocals_url:
    "https://media.mkv.so/usr_37caf97c-bae8-4621-8ac9-66cdb9103546/prj_f7a30e62-edfb-4ce2-9bed-f2c2b13e1e35/eBTPqmBC4eSMji8s.mp3.m4a",
  lyrics: [
    {
      id: 0,
      words: [
        {
          id: 0,
          text: "This",
          duration: 0.3,
          timestamp: 8.4,
        },
        {
          id: 1,
          text: "ain't",
          duration: 0.26,
          timestamp: 8.7,
        },
        {
          id: 2,
          text: "a",
          duration: 0.16,
          timestamp: 8.96,
        },
        {
          id: 3,
          text: "song",
          duration: 0.72,
          timestamp: 9.12,
        },
        {
          id: 4,
          text: "for",
          duration: 0.3,
          timestamp: 9.84,
        },
        {
          id: 5,
          text: "the",
          duration: 0.2,
          timestamp: 10.14,
        },
        {
          id: 6,
          text: "broken-hearted",
          duration: 1.966,
          syllables: [
            {
              id: 0,
              text: "broken",
              endOffset: 0.2,
            },
            {
              id: 1,
              text: "-hearted",
              endOffset: 1,
            },
          ],
          timestamp: 10.34,
        },
      ],
    },
    {
      id: 1,
      words: [
        {
          id: 0,
          text: "No",
          duration: 0.28,
          timestamp: 16.139,
        },
        {
          id: 1,
          text: "silent",
          duration: 0.72,
          timestamp: 16.419,
        },
        {
          id: 2,
          text: "prayer",
          duration: 0.74,
          timestamp: 17.139,
        },
        {
          id: 3,
          text: "for",
          duration: 0.54,
          timestamp: 17.879,
        },
        {
          id: 4,
          text: "faith",
          duration: 0.5,
          timestamp: 18.419,
        },
        {
          id: 5,
          text: "departed",
          duration: 1.44,
          syllables: [
            {
              id: 0,
              text: "de",
              endOffset: 0.2,
            },
            {
              id: 1,
              text: "par",
              endOffset: 0.4,
            },
            {
              id: 2,
              text: "ted",
              endOffset: 1,
            },
          ],
          timestamp: 18.919,
        },
      ],
    },
    {
      id: 2,
      words: [
        {
          id: 0,
          text: "I",
          duration: 0.24,
          timestamp: 24.439,
        },
        {
          id: 1,
          text: "ain't",
          duration: 0.24,
          timestamp: 24.679,
        },
        {
          id: 2,
          text: "gonna",
          duration: 0.5,
          timestamp: 24.919,
        },
        {
          id: 3,
          text: "be",
          duration: 0.48,
          timestamp: 25.419,
        },
        {
          id: 4,
          text: "just",
          duration: 0.32,
          timestamp: 25.899,
        },
        {
          id: 5,
          text: "a",
          duration: 0.18,
          timestamp: 26.219,
        },
        {
          id: 6,
          text: "face",
          duration: 0.38,
          timestamp: 26.399,
        },
        {
          id: 7,
          text: "in",
          duration: 0.16,
          timestamp: 26.779,
        },
        {
          id: 8,
          text: "the",
          duration: 0.22,
          timestamp: 26.939,
        },
        {
          id: 9,
          text: "crowd",
          duration: 0.44,
          timestamp: 27.159,
        },
      ],
    },
    {
      id: 3,
      words: [
        {
          id: 0,
          text: "You're",
          duration: 0.24,
          timestamp: 27.639,
        },
        {
          id: 1,
          text: "gonna",
          duration: 0.52,
          timestamp: 27.879,
        },
        {
          id: 2,
          text: "hear",
          duration: 0.5,
          timestamp: 28.399,
        },
        {
          id: 3,
          text: "my",
          duration: 0.5,
          timestamp: 28.899,
        },
        {
          id: 4,
          text: "voice",
          duration: 0.52,
          timestamp: 29.399,
        },
        {
          id: 5,
          text: "when",
          duration: 0.24,
          timestamp: 29.919,
        },
        {
          id: 6,
          text: "I",
          duration: 0.22,
          timestamp: 30.159,
        },
        {
          id: 7,
          text: "shout",
          duration: 0.38,
          timestamp: 30.379,
        },
        {
          id: 8,
          text: "it",
          duration: 0.2,
          timestamp: 30.759,
        },
        {
          id: 9,
          text: "out",
          duration: 0.48,
          timestamp: 30.959,
        },
        {
          id: 10,
          text: "loud",
          duration: 0.94,
          timestamp: 31.439,
        },
      ],
    },
    {
      id: 4,
      words: [
        {
          id: 0,
          text: "It's",
          duration: 0.46,
          timestamp: 33.419,
        },
        {
          id: 1,
          text: "my",
          duration: 0.62,
          timestamp: 33.879,
        },
        {
          id: 2,
          text: "life,",
          duration: 1.41,
          timestamp: 34.499,
        },
        {
          id: 3,
          text: "it's",
          duration: 0.24,
          timestamp: 35.938,
        },
        {
          id: 4,
          text: "now",
          duration: 0.54,
          timestamp: 36.178,
        },
        {
          id: 5,
          text: "or",
          duration: 0.46,
          timestamp: 36.718,
        },
        {
          id: 6,
          text: "never",
          duration: 1.18,
          timestamp: 37.178,
        },
      ],
    },
    {
      id: 5,
      words: [
        {
          id: 0,
          text: "But",
          duration: 0.26,
          timestamp: 39.118,
        },
        {
          id: 1,
          text: "I",
          duration: 0.2,
          timestamp: 39.378,
        },
        {
          id: 2,
          text: "ain't",
          duration: 0.32,
          timestamp: 39.578,
        },
        {
          id: 3,
          text: "gonna",
          duration: 0.52,
          timestamp: 39.898,
        },
        {
          id: 4,
          text: "live",
          duration: 0.48,
          timestamp: 40.418,
        },
        {
          id: 5,
          text: "forever",
          duration: 1.54,
          timestamp: 40.898,
        },
      ],
    },
    {
      id: 6,
      words: [
        {
          id: 0,
          text: "I",
          duration: 0.24,
          timestamp: 43.418,
        },
        {
          id: 1,
          text: "just",
          duration: 0.3,
          timestamp: 43.658,
        },
        {
          id: 2,
          text: "wanna",
          duration: 0.46,
          timestamp: 43.958,
        },
        {
          id: 3,
          text: "live",
          duration: 0.52,
          timestamp: 44.418,
        },
        {
          id: 4,
          text: "while",
          duration: 0.32,
          timestamp: 44.938,
        },
        {
          id: 5,
          text: "I'm",
          duration: 0.82,
          timestamp: 45.258,
        },
        {
          id: 6,
          text: "alive",
          duration: 1.78,
          timestamp: 46.078,
        },
      ],
    },
    {
      id: 7,
      words: [
        {
          id: 0,
          text: "(It's",
          duration: 0.5,
          timestamp: 49.418,
        },
        {
          id: 1,
          text: "my",
          duration: 0.46,
          timestamp: 49.918,
        },
        {
          id: 2,
          text: "life)",
          duration: 0.7,
          timestamp: 50.378,
        },
      ],
    },
    {
      id: 8,
      words: [
        {
          id: 0,
          text: "My",
          duration: 0.24,
          timestamp: 51.138,
        },
        {
          id: 1,
          text: "heart",
          duration: 0.32,
          timestamp: 51.378,
        },
        {
          id: 2,
          text: "is",
          duration: 0.2,
          timestamp: 51.698,
        },
        {
          id: 3,
          text: "like",
          duration: 0.3,
          timestamp: 51.898,
        },
        {
          id: 4,
          text: "an",
          duration: 0.22,
          timestamp: 52.198,
        },
        {
          id: 5,
          text: "open",
          duration: 0.96,
          timestamp: 52.418,
        },
        {
          id: 6,
          text: "highway",
          duration: 1.2,
          timestamp: 53.378,
        },
      ],
    },
    {
      id: 9,
      words: [
        {
          id: 0,
          text: "Like",
          duration: 0.28,
          timestamp: 55.138,
        },
        {
          id: 1,
          text: "Frankie",
          duration: 0.46,
          timestamp: 55.418,
        },
        {
          id: 2,
          text: "said,",
          duration: 0.32,
          timestamp: 55.878,
        },
        {
          id: 3,
          text: "I",
          duration: 0.26,
          timestamp: 56.198,
        },
        {
          id: 4,
          text: "did",
          duration: 0.54,
          timestamp: 56.458,
        },
        {
          id: 5,
          text: "it",
          duration: 0.24,
          timestamp: 56.998,
        },
      ],
    },
    {
      id: 10,
      words: [
        {
          id: 0,
          text: "My",
          duration: 0.5,
          timestamp: 57.398,
        },
        {
          id: 1,
          text: "way",
          duration: 1.48,
          timestamp: 57.898,
        },
      ],
    },
    {
      id: 11,
      words: [
        {
          id: 0,
          text: "I",
          duration: 0.28,
          timestamp: 59.438,
        },
        {
          id: 1,
          text: "just",
          duration: 0.22,
          timestamp: 59.718,
        },
        {
          id: 2,
          text: "wanna",
          duration: 0.446,
          timestamp: 59.971,
        },
        {
          id: 3,
          text: "live",
          duration: 0.54,
          timestamp: 60.417,
        },
        {
          id: 4,
          text: "while",
          duration: 0.22,
          timestamp: 60.957,
        },
        {
          id: 5,
          text: "I'm",
          duration: 0.24,
          timestamp: 61.837,
        },
        {
          id: 6,
          text: "alive",
          duration: 1.76,
          timestamp: 62.077,
        },
      ],
    },
    {
      id: 12,
      words: [
        {
          id: 0,
          text: "It's",
          duration: 0.9,
          timestamp: 64.477,
        },
        {
          id: 1,
          text: "my",
          duration: 1.06,
          timestamp: 65.377,
        },
        {
          id: 2,
          text: "life",
          duration: 0.5,
          timestamp: 66.437,
        },
      ],
    },
    {
      id: 13,
      words: [
        {
          id: 0,
          text: "Yeah,",
          duration: 0.26,
          timestamp: 74.137,
        },
        {
          id: 1,
          text: "this",
          duration: 0.28,
          timestamp: 74.397,
        },
        {
          id: 2,
          text: "is",
          duration: 0.24,
          timestamp: 74.677,
        },
        {
          id: 3,
          text: "for",
          duration: 0.5,
          timestamp: 74.917,
        },
        {
          id: 4,
          text: "ones",
          duration: 0.54,
          timestamp: 75.417,
        },
        {
          id: 5,
          text: "who",
          duration: 0.2,
          timestamp: 75.957,
        },
        {
          id: 6,
          text: "stood",
          duration: 0.52,
          timestamp: 76.157,
        },
        {
          id: 7,
          text: "their",
          duration: 0.5,
          timestamp: 76.677,
        },
        {
          id: 8,
          text: "ground",
          duration: 1.16,
          timestamp: 77.177,
        },
      ],
    },
    {
      id: 14,
      words: [
        {
          id: 0,
          text: "For",
          duration: 0.2,
          timestamp: 82.157,
        },
        {
          id: 1,
          text: "Tommy",
          duration: 0.6,
          timestamp: 82.357,
        },
        {
          id: 2,
          text: "and",
          duration: 0.18,
          timestamp: 82.957,
        },
        {
          id: 3,
          text: "Gina",
          duration: 1.02,
          timestamp: 83.137,
        },
        {
          id: 4,
          text: "who",
          duration: 0.251,
          timestamp: 84.165,
        },
        {
          id: 5,
          text: "never",
          duration: 0.52,
          timestamp: 84.416,
        },
        {
          id: 6,
          text: "backed",
          duration: 0.46,
          timestamp: 84.936,
        },
        {
          id: 7,
          text: "down",
          duration: 1.12,
          timestamp: 85.396,
        },
      ],
    },
    {
      id: 15,
      words: [
        {
          id: 0,
          text: "Tomorrow's",
          duration: 0.8,
          timestamp: 90.136,
        },
        {
          id: 1,
          text: "getting",
          duration: 0.46,
          timestamp: 90.936,
        },
        {
          id: 2,
          text: "harder,",
          duration: 0.52,
          timestamp: 91.396,
        },
        {
          id: 3,
          text: "make",
          duration: 0.46,
          timestamp: 91.916,
        },
        {
          id: 4,
          text: "no",
          duration: 0.34,
          timestamp: 92.376,
        },
        {
          id: 5,
          text: "mistake",
          duration: 1.14,
          timestamp: 92.716,
        },
      ],
    },
    {
      id: 16,
      words: [
        {
          id: 0,
          text: "Luck",
          duration: 0.588,
          timestamp: 94.045,
        },
        {
          id: 1,
          text: "ain't",
          duration: 0.5,
          timestamp: 94.633,
        },
        {
          id: 2,
          text: "enough,",
          duration: 0.451,
          timestamp: 95.133,
        },
        {
          id: 3,
          text: "you",
          duration: 0.24,
          timestamp: 95.636,
        },
        {
          id: 4,
          text: "gotta",
          duration: 0.5,
          timestamp: 95.876,
        },
        {
          id: 5,
          text: "make",
          duration: 0.28,
          timestamp: 96.376,
        },
        {
          id: 6,
          text: "your",
          duration: 0.3,
          timestamp: 96.656,
        },
        {
          id: 7,
          text: "own",
          duration: 0.44,
          timestamp: 96.956,
        },
        {
          id: 8,
          text: "breaks",
          duration: 1.38,
          timestamp: 97.396,
        },
      ],
    },
    {
      id: 17,
      words: [
        {
          id: 0,
          text: "It's",
          duration: 0.5,
          timestamp: 99.396,
        },
        {
          id: 1,
          text: "my",
          duration: 0.62,
          timestamp: 99.896,
        },
        {
          id: 2,
          text: "life,",
          duration: 1.2,
          timestamp: 100.516,
        },
        {
          id: 3,
          text: "and",
          duration: 0.22,
          timestamp: 101.716,
        },
        {
          id: 4,
          text: "it's",
          duration: 0.22,
          timestamp: 101.936,
        },
        {
          id: 5,
          text: "now",
          duration: 0.54,
          timestamp: 102.156,
        },
        {
          id: 6,
          text: "or",
          duration: 0.48,
          timestamp: 102.696,
        },
        {
          id: 7,
          text: "never",
          duration: 1.22,
          timestamp: 103.176,
        },
      ],
    },
    {
      id: 18,
      words: [
        {
          id: 0,
          text: "I",
          duration: 0.22,
          timestamp: 105.376,
        },
        {
          id: 1,
          text: "ain't",
          duration: 0.3,
          timestamp: 105.596,
        },
        {
          id: 2,
          text: "gonna",
          duration: 0.48,
          timestamp: 105.896,
        },
        {
          id: 3,
          text: "live",
          duration: 0.5,
          timestamp: 106.376,
        },
        {
          id: 4,
          text: "forever",
          duration: 1.56,
          timestamp: 106.876,
        },
      ],
    },
    {
      id: 19,
      words: [
        {
          id: 0,
          text: "I",
          duration: 0.28,
          timestamp: 109.375,
        },
        {
          id: 1,
          text: "just",
          duration: 0.28,
          timestamp: 109.655,
        },
        {
          id: 2,
          text: "wanna",
          duration: 0.48,
          timestamp: 109.935,
        },
        {
          id: 3,
          text: "live",
          duration: 0.54,
          timestamp: 110.415,
        },
        {
          id: 4,
          text: "while",
          duration: 0.88,
          timestamp: 110.955,
        },
        {
          id: 5,
          text: "I'm",
          duration: 0.22,
          timestamp: 111.835,
        },
        {
          id: 6,
          text: "alive",
          duration: 1.82,
          timestamp: 112.055,
        },
      ],
    },
    {
      id: 20,
      words: [
        {
          id: 0,
          text: "(It's",
          duration: 0.48,
          timestamp: 115.435,
        },
        {
          id: 1,
          text: "my",
          duration: 0.52,
          timestamp: 115.915,
        },
        {
          id: 2,
          text: "life)",
          duration: 0.68,
          timestamp: 116.435,
        },
      ],
    },
    {
      id: 21,
      words: [
        {
          id: 0,
          text: "My",
          duration: 0.2,
          timestamp: 117.135,
        },
        {
          id: 1,
          text: "heart",
          duration: 0.36,
          timestamp: 117.335,
        },
        {
          id: 2,
          text: "is",
          duration: 0.22,
          timestamp: 117.695,
        },
        {
          id: 3,
          text: "like",
          duration: 0.28,
          timestamp: 117.915,
        },
        {
          id: 4,
          text: "an",
          duration: 0.2,
          timestamp: 118.195,
        },
        {
          id: 5,
          text: "open",
          duration: 0.88,
          timestamp: 118.395,
        },
        {
          id: 6,
          text: "highway",
          duration: 1.5,
          timestamp: 119.275,
        },
      ],
    },
    {
      id: 22,
      words: [
        {
          id: 0,
          text: "Like",
          duration: 0.22,
          timestamp: 121.135,
        },
        {
          id: 1,
          text: "Frankie",
          duration: 0.46,
          timestamp: 121.355,
        },
        {
          id: 2,
          text: "said,",
          duration: 0.32,
          timestamp: 121.815,
        },
        {
          id: 3,
          text: "I",
          duration: 0.26,
          timestamp: 122.135,
        },
        {
          id: 4,
          text: "did",
          duration: 0.56,
          timestamp: 122.395,
        },
        {
          id: 5,
          text: "it",
          duration: 0.34,
          timestamp: 122.955,
        },
      ],
    },
    {
      id: 23,
      words: [
        {
          id: 0,
          text: "My",
          duration: 0.5,
          timestamp: 123.375,
        },
        {
          id: 1,
          text: "way",
          duration: 0.92,
          timestamp: 123.875,
        },
      ],
    },
    {
      id: 24,
      words: [
        {
          id: 0,
          text: "I",
          duration: 0.28,
          timestamp: 125.435,
        },
        {
          id: 1,
          text: "just",
          duration: 0.24,
          timestamp: 125.715,
        },
        {
          id: 2,
          text: "wanna",
          duration: 0.48,
          timestamp: 125.955,
        },
        {
          id: 3,
          text: "live",
          duration: 0.5,
          timestamp: 126.435,
        },
        {
          id: 4,
          text: "while",
          duration: 0.3,
          timestamp: 126.935,
        },
        {
          id: 5,
          text: "I'm",
          duration: 0.82,
          timestamp: 127.235,
        },
        {
          id: 6,
          text: "alive",
          duration: 1.8,
          timestamp: 128.055,
        },
      ],
    },
    {
      id: 25,
      words: [
        {
          id: 0,
          text: "'Cause",
          duration: 0.34,
          timestamp: 130.115,
        },
        {
          id: 1,
          text: "it's",
          duration: 0.92,
          timestamp: 130.455,
        },
        {
          id: 2,
          text: "my",
          duration: 1.06,
          timestamp: 131.375,
        },
        {
          id: 3,
          text: "life",
          duration: 1.671,
          timestamp: 132.443,
        },
      ],
    },
    {
      id: 26,
      words: [
        {
          id: 0,
          text: "Better",
          duration: 0.44,
          timestamp: 148.414,
        },
        {
          id: 1,
          text: "stand",
          duration: 0.58,
          timestamp: 148.854,
        },
        {
          id: 2,
          text: "tall",
          duration: 0.54,
          timestamp: 149.434,
        },
        {
          id: 3,
          text: "when",
          duration: 0.22,
          timestamp: 149.974,
        },
        {
          id: 4,
          text: "they're",
          duration: 0.24,
          timestamp: 150.194,
        },
        {
          id: 5,
          text: "calling",
          duration: 0.52,
          timestamp: 150.434,
        },
        {
          id: 6,
          text: "you",
          duration: 0.26,
          timestamp: 150.954,
        },
        {
          id: 7,
          text: "out",
          duration: 0.68,
          timestamp: 151.214,
        },
      ],
    },
    {
      id: 27,
      words: [
        {
          id: 0,
          text: "Don't",
          duration: 0.48,
          timestamp: 151.954,
        },
        {
          id: 1,
          text: "bend,",
          duration: 0.5,
          timestamp: 152.434,
        },
        {
          id: 2,
          text: "don't",
          duration: 0.48,
          timestamp: 152.934,
        },
        {
          id: 3,
          text: "break,",
          duration: 0.54,
          timestamp: 153.414,
        },
        {
          id: 4,
          text: "baby,",
          duration: 0.5,
          timestamp: 153.954,
        },
        {
          id: 5,
          text: "don't",
          duration: 0.5,
          timestamp: 154.454,
        },
        {
          id: 6,
          text: "back",
          duration: 0.5,
          timestamp: 154.954,
        },
        {
          id: 7,
          text: "down",
          duration: 0.877,
          timestamp: 155.476,
        },
      ],
    },
    {
      id: 28,
      words: [
        {
          id: 0,
          text: "It's",
          duration: 0.46,
          timestamp: 157.453,
        },
        {
          id: 1,
          text: "my",
          duration: 0.58,
          timestamp: 157.913,
        },
        {
          id: 2,
          text: "life,",
          duration: 1.22,
          timestamp: 158.493,
        },
        {
          id: 3,
          text: "and",
          duration: 0.28,
          timestamp: 159.713,
        },
        {
          id: 4,
          text: "it's",
          duration: 0.22,
          timestamp: 159.993,
        },
        {
          id: 5,
          text: "now",
          duration: 0.48,
          timestamp: 160.213,
        },
        {
          id: 6,
          text: "or",
          duration: 0.46,
          timestamp: 160.693,
        },
        {
          id: 7,
          text: "never",
          duration: 1.12,
          timestamp: 161.153,
        },
      ],
    },
    {
      id: 29,
      words: [
        {
          id: 0,
          text: "'Cause",
          duration: 0.28,
          timestamp: 163.133,
        },
        {
          id: 1,
          text: "I",
          duration: 0.24,
          timestamp: 163.413,
        },
        {
          id: 2,
          text: "ain't",
          duration: 0.28,
          timestamp: 163.653,
        },
        {
          id: 3,
          text: "gonna",
          duration: 0.5,
          timestamp: 163.933,
        },
        {
          id: 4,
          text: "live",
          duration: 0.5,
          timestamp: 164.433,
        },
        {
          id: 5,
          text: "forever",
          duration: 1.86,
          timestamp: 164.933,
        },
      ],
    },
    {
      id: 30,
      words: [
        {
          id: 0,
          text: "I",
          duration: 0.28,
          timestamp: 167.413,
        },
        {
          id: 1,
          text: "just",
          duration: 0.24,
          timestamp: 167.693,
        },
        {
          id: 2,
          text: "wanna",
          duration: 0.48,
          timestamp: 167.933,
        },
        {
          id: 3,
          text: "live",
          duration: 0.54,
          timestamp: 168.413,
        },
        {
          id: 4,
          text: "while",
          duration: 0.32,
          timestamp: 168.953,
        },
        {
          id: 5,
          text: "I'm",
          duration: 0.76,
          timestamp: 169.273,
        },
        {
          id: 6,
          text: "alive",
          duration: 1.84,
          timestamp: 170.033,
        },
      ],
    },
    {
      id: 31,
      words: [
        {
          id: 0,
          text: "(It's",
          duration: 0.5,
          timestamp: 173.413,
        },
        {
          id: 1,
          text: "my",
          duration: 0.5,
          timestamp: 173.913,
        },
        {
          id: 2,
          text: "life)",
          duration: 0.62,
          timestamp: 174.413,
        },
      ],
    },
    {
      id: 32,
      words: [
        {
          id: 0,
          text: "My",
          duration: 0.3,
          timestamp: 175.133,
        },
        {
          id: 1,
          text: "heart",
          duration: 0.3,
          timestamp: 175.433,
        },
        {
          id: 2,
          text: "is",
          duration: 0.2,
          timestamp: 175.733,
        },
        {
          id: 3,
          text: "like",
          duration: 0.3,
          timestamp: 175.933,
        },
        {
          id: 4,
          text: "an",
          duration: 0.24,
          timestamp: 176.233,
        },
        {
          id: 5,
          text: "open",
          duration: 0.92,
          timestamp: 176.473,
        },
        {
          id: 6,
          text: "highway",
          duration: 1.16,
          timestamp: 177.393,
        },
      ],
    },
    {
      id: 33,
      words: [
        {
          id: 0,
          text: "Like",
          duration: 0.28,
          timestamp: 179.133,
        },
        {
          id: 1,
          text: "Frankie",
          duration: 0.414,
          timestamp: 179.438,
        },
        {
          id: 2,
          text: "said,",
          duration: 0.34,
          timestamp: 179.852,
        },
        {
          id: 3,
          text: "I",
          duration: 0.22,
          timestamp: 180.192,
        },
        {
          id: 4,
          text: "did",
          duration: 0.56,
          timestamp: 180.412,
        },
        {
          id: 5,
          text: "it",
          duration: 0.4,
          timestamp: 180.972,
        },
      ],
    },
    {
      id: 34,
      words: [
        {
          id: 0,
          text: "My",
          duration: 0.5,
          timestamp: 181.392,
        },
        {
          id: 1,
          text: "way",
          duration: 1,
          timestamp: 181.892,
        },
      ],
    },
    {
      id: 35,
      words: [
        {
          id: 0,
          text: "I",
          duration: 0.26,
          timestamp: 183.452,
        },
        {
          id: 1,
          text: "just",
          duration: 0.24,
          timestamp: 183.712,
        },
        {
          id: 2,
          text: "wanna",
          duration: 0.46,
          timestamp: 183.952,
        },
        {
          id: 3,
          text: "live",
          duration: 0.52,
          timestamp: 184.412,
        },
        {
          id: 4,
          text: "while",
          duration: 0.32,
          timestamp: 184.932,
        },
        {
          id: 5,
          text: "I'm",
          duration: 0.78,
          timestamp: 185.252,
        },
        {
          id: 6,
          text: "alive",
          duration: 1.84,
          timestamp: 186.032,
        },
      ],
    },
    {
      id: 36,
      words: [
        {
          id: 0,
          text: "(It's",
          duration: 1.48,
          timestamp: 188.452,
        },
        {
          id: 1,
          text: "my",
          duration: 0.46,
          timestamp: 189.932,
        },
        {
          id: 2,
          text: "life)",
          duration: 0.46,
          timestamp: 190.392,
        },
      ],
    },
    {
      id: 37,
      words: [
        {
          id: 0,
          text: "Yeah,",
          duration: 0.32,
          timestamp: 191.632,
        },
        {
          id: 1,
          text: "it's",
          duration: 0.22,
          timestamp: 191.952,
        },
        {
          id: 2,
          text: "now",
          duration: 0.58,
          timestamp: 192.172,
        },
        {
          id: 3,
          text: "or",
          duration: 0.42,
          timestamp: 192.752,
        },
        {
          id: 4,
          text: "never",
          duration: 1.2,
          timestamp: 193.172,
        },
      ],
    },
    {
      id: 38,
      words: [
        {
          id: 0,
          text: "I",
          duration: 0.18,
          timestamp: 195.392,
        },
        {
          id: 1,
          text: "ain't",
          duration: 0.34,
          timestamp: 195.572,
        },
        {
          id: 2,
          text: "gonna",
          duration: 0.54,
          timestamp: 195.912,
        },
        {
          id: 3,
          text: "live",
          duration: 0.46,
          timestamp: 196.452,
        },
        {
          id: 4,
          text: "forever",
          duration: 2,
          timestamp: 196.912,
        },
      ],
    },
    {
      id: 39,
      words: [
        {
          id: 0,
          text: "I",
          duration: 0.28,
          timestamp: 199.412,
        },
        {
          id: 1,
          text: "just",
          duration: 0.26,
          timestamp: 199.692,
        },
        {
          id: 2,
          text: "wanna",
          duration: 0.48,
          timestamp: 199.952,
        },
        {
          id: 3,
          text: "live",
          duration: 0.52,
          timestamp: 200.432,
        },
        {
          id: 4,
          text: "while",
          duration: 0.68,
          timestamp: 200.952,
        },
        {
          id: 5,
          text: "I'm",
          duration: 0.42,
          timestamp: 201.632,
        },
        {
          id: 6,
          text: "alive",
          duration: 1.82,
          timestamp: 202.052,
        },
      ],
    },
    {
      id: 40,
      words: [
        {
          id: 0,
          text: "(It's",
          duration: 0.48,
          timestamp: 205.431,
        },
        {
          id: 1,
          text: "my",
          duration: 0.48,
          timestamp: 205.911,
        },
        {
          id: 2,
          text: "life)",
          duration: 0.3,
          timestamp: 206.391,
        },
      ],
    },
    {
      id: 41,
      words: [
        {
          id: 0,
          text: "My",
          duration: 0.1,
          timestamp: 206.811,
        },
        {
          id: 1,
          text: "heart",
          duration: 0.8,
          timestamp: 206.911,
        },
        {
          id: 2,
          text: "is",
          duration: 0.18,
          timestamp: 207.711,
        },
        {
          id: 3,
          text: "like",
          duration: 0.32,
          timestamp: 207.891,
        },
        {
          id: 4,
          text: "an",
          duration: 0.22,
          timestamp: 208.211,
        },
        {
          id: 5,
          text: "open",
          duration: 0.94,
          timestamp: 208.431,
        },
        {
          id: 6,
          text: "highway",
          duration: 1.18,
          timestamp: 209.371,
        },
      ],
    },
    {
      id: 42,
      words: [
        {
          id: 0,
          text: "Like",
          duration: 0.3,
          timestamp: 211.111,
        },
        {
          id: 1,
          text: "Frankie",
          duration: 0.48,
          timestamp: 211.411,
        },
        {
          id: 2,
          text: "said,",
          duration: 0.3,
          timestamp: 211.891,
        },
        {
          id: 3,
          text: "I",
          duration: 0.28,
          timestamp: 212.191,
        },
        {
          id: 4,
          text: "did",
          duration: 0.56,
          timestamp: 212.471,
        },
        {
          id: 5,
          text: "it",
          duration: 0.3,
          timestamp: 213.031,
        },
      ],
    },
    {
      id: 43,
      words: [
        {
          id: 0,
          text: "My",
          duration: 0.52,
          timestamp: 213.391,
        },
        {
          id: 1,
          text: "way",
          duration: 0.86,
          timestamp: 213.911,
        },
      ],
    },
    {
      id: 44,
      words: [
        {
          id: 0,
          text: "I",
          duration: 0.26,
          timestamp: 215.471,
        },
        {
          id: 1,
          text: "just",
          duration: 0.24,
          timestamp: 215.731,
        },
        {
          id: 2,
          text: "wanna",
          duration: 0.48,
          timestamp: 215.971,
        },
        {
          id: 3,
          text: "live",
          duration: 0.52,
          timestamp: 216.451,
        },
        {
          id: 4,
          text: "while",
          duration: 0.24,
          timestamp: 216.971,
        },
        {
          id: 5,
          text: "I'm",
          duration: 0.32,
          timestamp: 217.751,
        },
        {
          id: 6,
          text: "alive",
          duration: 1.82,
          timestamp: 218.071,
        },
      ],
    },
    {
      id: 45,
      words: [
        {
          id: 0,
          text: "'Cause",
          duration: 0.34,
          timestamp: 220.111,
        },
        {
          id: 1,
          text: "it's",
          duration: 0.94,
          timestamp: 220.451,
        },
        {
          id: 2,
          text: "my",
          duration: 1,
          timestamp: 221.391,
        },
        {
          id: 3,
          text: "life",
          duration: 0.52,
          timestamp: 222.391,
        },
      ],
    },
  ],
};

export const DEV_PROJECT_2: TablesInsert<"projects"> = {
  id: "53a53d6e-fa8b-4a68-802c-4fe732049fcf",
  user_id: DEV_USER_PREMIUM.id,
  title: "Hot Milk - Where Does The Light Get In?",
  duration_in_seconds: 189,
  original_url:
    "https://media.mkv.so/usr_37caf97c-bae8-4621-8ac9-66cdb9103546/prj_53a53d6e-fa8b-4a68-802c-4fe732049fcf/original.m4a",
  instrumental_url:
    "https://media.mkv.so/usr_37caf97c-bae8-4621-8ac9-66cdb9103546/prj_53a53d6e-fa8b-4a68-802c-4fe732049fcf/instrumental.m4a",
  vocals_url:
    "https://media.mkv.so/usr_37caf97c-bae8-4621-8ac9-66cdb9103546/prj_53a53d6e-fa8b-4a68-802c-4fe732049fcf/vocals.m4a",
  vocals_lead_url:
    "https://media.mkv.so/usr_37caf97c-bae8-4621-8ac9-66cdb9103546/prj_53a53d6e-fa8b-4a68-802c-4fe732049fcf/lead_vocals.m4a",
  vocals_backing_url:
    "https://media.mkv.so/usr_37caf97c-bae8-4621-8ac9-66cdb9103546/prj_53a53d6e-fa8b-4a68-802c-4fe732049fcf/backing_vocals.m4a",
  lyrics: [
    {
      id: 0,
      words: [
        {
          id: 0,
          text: "Mother,",
          duration: 0.75,
          timestamp: 25.141,
        },
        {
          id: 1,
          text: "raise",
          duration: 0.35,
          timestamp: 25.901,
        },
        {
          id: 2,
          text: "me",
          duration: 0.29,
          timestamp: 26.261,
        },
        {
          id: 3,
          text: "from",
          duration: 0.35,
          timestamp: 26.561,
        },
        {
          id: 4,
          text: "my",
          duration: 0.17,
          timestamp: 26.921,
        },
        {
          id: 5,
          text: "bed",
          duration: 0.46,
          timestamp: 27.101,
        },
      ],
    },
    {
      id: 1,
      words: [
        {
          id: 0,
          text: "Been",
          duration: 0.37,
          timestamp: 27.641,
        },
        {
          id: 1,
          text: "eating",
          duration: 0.73,
          timestamp: 28.021,
        },
        {
          id: 2,
          text: "existential",
          duration: 1.13,
          timestamp: 28.761,
        },
        {
          id: 3,
          text: "dread",
          duration: 0.89,
          timestamp: 29.901,
        },
        {
          id: 4,
          text: "for",
          duration: 0.31,
          timestamp: 30.801,
        },
        {
          id: 5,
          text: "breakfast",
          duration: 1.04,
          timestamp: 31.121,
        },
      ],
    },
    {
      id: 2,
      words: [
        {
          id: 0,
          text: "This",
          duration: 0.35,
          timestamp: 32.201,
        },
        {
          id: 1,
          text: "tempest",
          duration: 1.01,
          timestamp: 32.561,
        },
        {
          id: 2,
          text: "washed",
          duration: 0.37,
          timestamp: 33.581,
        },
        {
          id: 3,
          text: "out",
          duration: 0.35,
          timestamp: 33.961,
        },
        {
          id: 4,
          text: "all",
          duration: 0.49,
          timestamp: 34.321,
        },
        {
          id: 5,
          text: "the",
          duration: 0.19,
          timestamp: 34.821,
        },
        {
          id: 6,
          text: "color",
          duration: 0.67,
          timestamp: 35.021,
        },
        {
          id: 7,
          text: "'cause",
          duration: 0.55,
          timestamp: 35.701,
        },
        {
          id: 8,
          text: "another",
          duration: 0.78,
          timestamp: 36.261,
        },
      ],
    },
    {
      id: 3,
      words: [
        {
          id: 0,
          text: "Threw",
          duration: 0.39,
          timestamp: 37.081,
        },
        {
          id: 1,
          text: "me",
          duration: 0.29,
          timestamp: 37.481,
        },
        {
          id: 2,
          text: "to",
          duration: 0.39,
          timestamp: 37.781,
        },
        {
          id: 3,
          text: "the",
          duration: 0.15,
          timestamp: 38.181,
        },
        {
          id: 4,
          text: "wolves",
          duration: 0.52,
          timestamp: 38.341,
        },
      ],
    },
    {
      id: 4,
      words: [
        {
          id: 0,
          text: "Tore",
          duration: 0.41,
          timestamp: 39.201,
        },
        {
          id: 1,
          text: "out",
          duration: 0.29,
          timestamp: 39.621,
        },
        {
          id: 2,
          text: "all",
          duration: 0.33,
          timestamp: 39.921,
        },
        {
          id: 3,
          text: "my",
          duration: 0.33,
          timestamp: 40.261,
        },
        {
          id: 4,
          text: "ventricles",
          duration: 1.04,
          timestamp: 40.601,
        },
      ],
    },
    {
      id: 5,
      words: [
        {
          id: 0,
          text: "Put",
          duration: 0.35,
          timestamp: 41.981,
        },
        {
          id: 1,
          text: "plainly",
          duration: 1.05,
          timestamp: 42.341,
        },
        {
          id: 2,
          text: "I'm",
          duration: 0.31,
          timestamp: 43.401,
        },
        {
          id: 3,
          text: "hurting",
          duration: 1.04,
          timestamp: 43.721,
        },
      ],
    },
    {
      id: 6,
      words: [
        {
          id: 0,
          text: "But",
          duration: 0.31,
          timestamp: 44.821,
        },
        {
          id: 1,
          text: "did",
          duration: 0.75,
          timestamp: 45.141,
        },
        {
          id: 2,
          text: "I",
          duration: 0.31,
          timestamp: 45.901,
        },
        {
          id: 3,
          text: "deserve",
          duration: 1.09,
          timestamp: 46.221,
        },
        {
          id: 4,
          text: "it?",
          duration: 1.56,
          timestamp: 47.321,
        },
      ],
    },
    {
      id: 7,
      words: [
        {
          id: 0,
          text: "Saw",
          duration: 0.27,
          timestamp: 49.321,
        },
        {
          id: 1,
          text: "the",
          duration: 0.13,
          timestamp: 49.601,
        },
        {
          id: 2,
          text: "tears",
          duration: 0.21,
          timestamp: 49.741,
        },
        {
          id: 3,
          text: "on",
          duration: 0.11,
          timestamp: 49.961,
        },
        {
          id: 4,
          text: "your",
          duration: 0.39,
          timestamp: 50.081,
        },
        {
          id: 5,
          text: "note",
          duration: 0.52,
          timestamp: 50.481,
        },
      ],
    },
    {
      id: 8,
      words: [
        {
          id: 0,
          text: "Guess",
          duration: 0.25,
          timestamp: 52.141,
        },
        {
          id: 1,
          text: "I'm",
          duration: 0.17,
          timestamp: 52.401,
        },
        {
          id: 2,
          text: "never",
          duration: 0.31,
          timestamp: 52.581,
        },
        {
          id: 3,
          text: "coming",
          duration: 0.31,
          timestamp: 52.901,
        },
        {
          id: 4,
          text: "home",
          duration: 0.36,
          timestamp: 53.221,
        },
      ],
    },
    {
      id: 9,
      words: [
        {
          id: 0,
          text: "Where",
          duration: 0.39,
          timestamp: 53.901,
        },
        {
          id: 1,
          text: "does",
          duration: 0.31,
          timestamp: 54.301,
        },
        {
          id: 2,
          text: "the",
          duration: 0.35,
          timestamp: 54.621,
        },
        {
          id: 3,
          text: "light",
          duration: 0.67,
          timestamp: 54.981,
        },
        {
          id: 4,
          text: "get",
          duration: 0.75,
          timestamp: 55.661,
        },
        {
          id: 5,
          text: "in?",
          duration: 0.18,
          timestamp: 56.421,
        },
      ],
    },
    {
      id: 10,
      words: [
        {
          id: 0,
          text: "(Darkness",
          duration: 0.21,
          timestamp: 56.661,
        },
        {
          id: 1,
          text: "penetrating,",
          duration: 0.55,
          timestamp: 56.881,
        },
        {
          id: 2,
          text: "this",
          duration: 0.89,
          timestamp: 57.441,
        },
        {
          id: 3,
          text: "is",
          duration: 0.13,
          timestamp: 58.341,
        },
        {
          id: 4,
          text: "suffocating)",
          duration: 1,
          timestamp: 58.481,
        },
      ],
    },
    {
      id: 11,
      words: [
        {
          id: 0,
          text: "Where",
          duration: 0.43,
          timestamp: 59.521,
        },
        {
          id: 1,
          text: "does",
          duration: 0.31,
          timestamp: 59.961,
        },
        {
          id: 2,
          text: "the",
          duration: 0.31,
          timestamp: 60.281,
        },
        {
          id: 3,
          text: "light",
          duration: 0.71,
          timestamp: 60.601,
        },
        {
          id: 4,
          text: "get",
          duration: 0.69,
          timestamp: 61.321,
        },
        {
          id: 5,
          text: "in?",
          duration: 0.14,
          timestamp: 62.021,
        },
      ],
    },
    {
      id: 12,
      words: [
        {
          id: 0,
          text: "(Darkness",
          duration: 0.29,
          timestamp: 62.201,
        },
        {
          id: 1,
          text: "penetrating,",
          duration: 1.23,
          timestamp: 62.501,
        },
        {
          id: 2,
          text: "I'm",
          duration: 0.17,
          timestamp: 63.741,
        },
        {
          id: 3,
          text: "contaminated)",
          duration: 0.5,
          timestamp: 63.921,
        },
      ],
    },
    {
      id: 13,
      words: [
        {
          id: 0,
          text: "All",
          duration: 0.35,
          timestamp: 64.481,
        },
        {
          id: 1,
          text: "the",
          duration: 0.35,
          timestamp: 64.841,
        },
        {
          id: 2,
          text: "things",
          duration: 0.63,
          timestamp: 65.201,
        },
        {
          id: 3,
          text: "that",
          duration: 0.27,
          timestamp: 65.841,
        },
        {
          id: 4,
          text: "I've",
          duration: 0.45,
          timestamp: 66.121,
        },
        {
          id: 5,
          text: "done",
          duration: 0.69,
          timestamp: 66.581,
        },
        {
          id: 6,
          text: "for",
          duration: 0.39,
          timestamp: 67.281,
        },
        {
          id: 7,
          text: "a",
          duration: 0.27,
          timestamp: 67.681,
        },
        {
          id: 8,
          text: "kiss",
          duration: 0.69,
          timestamp: 67.961,
        },
        {
          id: 9,
          text: "from",
          duration: 0.19,
          timestamp: 68.661,
        },
        {
          id: 10,
          text: "the",
          duration: 0.49,
          timestamp: 68.861,
        },
        {
          id: 11,
          text: "sun",
          duration: 0.66,
          timestamp: 69.361,
        },
      ],
    },
    {
      id: 14,
      words: [
        {
          id: 0,
          text: "Tell",
          duration: 0.35,
          timestamp: 70.061,
        },
        {
          id: 1,
          text: "me,",
          duration: 0.31,
          timestamp: 70.421,
        },
        {
          id: 2,
          text: "where",
          duration: 0.39,
          timestamp: 70.741,
        },
        {
          id: 3,
          text: "does",
          duration: 0.33,
          timestamp: 71.142,
        },
        {
          id: 4,
          text: "the",
          duration: 0.35,
          timestamp: 71.482,
        },
        {
          id: 5,
          text: "light",
          duration: 0.67,
          timestamp: 71.842,
        },
        {
          id: 6,
          text: "get",
          duration: 0.75,
          timestamp: 72.522,
        },
        {
          id: 7,
          text: "in?",
          duration: 1.72,
          timestamp: 73.282,
        },
      ],
    },
    {
      id: 15,
      words: [
        {
          id: 0,
          text: "Another",
          duration: 0.81,
          timestamp: 75.582,
        },
        {
          id: 1,
          text: "day",
          duration: 0.33,
          timestamp: 76.402,
        },
        {
          id: 2,
          text: "draped",
          duration: 0.43,
          timestamp: 76.742,
        },
        {
          id: 3,
          text: "in",
          duration: 0.27,
          timestamp: 77.182,
        },
        {
          id: 4,
          text: "dismay",
          duration: 0.68,
          timestamp: 77.462,
        },
      ],
    },
    {
      id: 16,
      words: [
        {
          id: 0,
          text: "Supernova",
          duration: 1.45,
          timestamp: 78.482,
        },
        {
          id: 1,
          text: "in",
          duration: 0.17,
          timestamp: 79.942,
        },
        {
          id: 2,
          text: "decay",
          duration: 0.84,
          timestamp: 80.122,
        },
      ],
    },
    {
      id: 17,
      words: [
        {
          id: 0,
          text: "Affection,",
          duration: 1.41,
          timestamp: 81.342,
        },
        {
          id: 1,
          text: "infection",
          duration: 1.28,
          timestamp: 82.762,
        },
      ],
    },
    {
      id: 18,
      words: [
        {
          id: 0,
          text: "Cross",
          duration: 0.35,
          timestamp: 84.142,
        },
        {
          id: 1,
          text: "my",
          duration: 0.29,
          timestamp: 84.502,
        },
        {
          id: 2,
          text: "heart",
          duration: 0.53,
          timestamp: 84.802,
        },
        {
          id: 3,
          text: "and",
          duration: 0.17,
          timestamp: 85.342,
        },
        {
          id: 4,
          text: "pray",
          duration: 0.51,
          timestamp: 85.522,
        },
        {
          id: 5,
          text: "for",
          duration: 0.21,
          timestamp: 86.042,
        },
        {
          id: 6,
          text: "resurrection",
          duration: 1.34,
          timestamp: 86.262,
        },
      ],
    },
    {
      id: 19,
      words: [
        {
          id: 0,
          text: "Your",
          duration: 0.17,
          timestamp: 87.802,
        },
        {
          id: 1,
          text: "hollow",
          duration: 0.35,
          timestamp: 87.982,
        },
        {
          id: 2,
          text: "ground",
          duration: 0.31,
          timestamp: 88.342,
        },
        {
          id: 3,
          text: "grew",
          duration: 0.25,
          timestamp: 88.662,
        },
        {
          id: 4,
          text: "a",
          duration: 0.11,
          timestamp: 88.922,
        },
        {
          id: 5,
          text: "barren",
          duration: 0.33,
          timestamp: 89.042,
        },
        {
          id: 6,
          text: "tree",
          duration: 0.76,
          timestamp: 89.382,
        },
      ],
    },
    {
      id: 20,
      words: [
        {
          id: 0,
          text: "Your",
          duration: 0.19,
          timestamp: 90.622,
        },
        {
          id: 1,
          text: "false",
          duration: 0.31,
          timestamp: 90.822,
        },
        {
          id: 2,
          text: "gods",
          duration: 0.37,
          timestamp: 91.142,
        },
        {
          id: 3,
          text: "lie",
          duration: 0.37,
          timestamp: 91.522,
        },
        {
          id: 4,
          text: "in",
          duration: 0.29,
          timestamp: 91.902,
        },
        {
          id: 5,
          text: "debris",
          duration: 1.58,
          timestamp: 92.202,
        },
      ],
    },
    {
      id: 21,
      words: [
        {
          id: 0,
          text: "You",
          duration: 0.19,
          timestamp: 94.122,
        },
        {
          id: 1,
          text: "rip",
          duration: 0.15,
          timestamp: 94.322,
        },
        {
          id: 2,
          text: "the",
          duration: 0.15,
          timestamp: 94.482,
        },
        {
          id: 3,
          text: "meat",
          duration: 0.25,
          timestamp: 94.642,
        },
        {
          id: 4,
          text: "from",
          duration: 0.21,
          timestamp: 94.902,
        },
        {
          id: 5,
          text: "my",
          duration: 0.23,
          timestamp: 95.122,
        },
        {
          id: 6,
          text: "bones",
          duration: 0.66,
          timestamp: 95.362,
        },
      ],
    },
    {
      id: 22,
      words: [
        {
          id: 0,
          text: "And",
          duration: 0.13,
          timestamp: 96.242,
        },
        {
          id: 1,
          text: "leave",
          duration: 0.31,
          timestamp: 96.382,
        },
        {
          id: 2,
          text: "nothing",
          duration: 0.35,
          timestamp: 96.702,
        },
        {
          id: 3,
          text: "for",
          duration: 0.15,
          timestamp: 97.062,
        },
        {
          id: 4,
          text: "the",
          duration: 0.17,
          timestamp: 97.222,
        },
        {
          id: 5,
          text: "crows",
          duration: 1.12,
          timestamp: 97.402,
        },
      ],
    },
    {
      id: 23,
      words: [
        {
          id: 0,
          text: "Where",
          duration: 0.37,
          timestamp: 98.822,
        },
        {
          id: 1,
          text: "does",
          duration: 0.33,
          timestamp: 99.202,
        },
        {
          id: 2,
          text: "the",
          duration: 0.33,
          timestamp: 99.542,
        },
        {
          id: 3,
          text: "light",
          duration: 0.67,
          timestamp: 99.882,
        },
        {
          id: 4,
          text: "get",
          duration: 0.77,
          timestamp: 100.562,
        },
        {
          id: 5,
          text: "in?",
          duration: 0.16,
          timestamp: 101.342,
        },
      ],
    },
    {
      id: 24,
      words: [
        {
          id: 0,
          text: "(Darkness",
          duration: 0.25,
          timestamp: 101.542,
        },
        {
          id: 1,
          text: "penetrating,",
          duration: 0.57,
          timestamp: 101.802,
        },
        {
          id: 2,
          text: "this",
          duration: 0.85,
          timestamp: 102.382,
        },
        {
          id: 3,
          text: "is",
          duration: 0.15,
          timestamp: 103.242,
        },
        {
          id: 4,
          text: "suffocating)",
          duration: 1,
          timestamp: 103.402,
        },
      ],
    },
    {
      id: 25,
      words: [
        {
          id: 0,
          text: "Where",
          duration: 0.43,
          timestamp: 104.442,
        },
        {
          id: 1,
          text: "does",
          duration: 0.31,
          timestamp: 104.882,
        },
        {
          id: 2,
          text: "the",
          duration: 0.29,
          timestamp: 105.202,
        },
        {
          id: 3,
          text: "light",
          duration: 0.71,
          timestamp: 105.502,
        },
        {
          id: 4,
          text: "get",
          duration: 0.93,
          timestamp: 106.222,
        },
        {
          id: 5,
          text: "in?",
          duration: 0.22,
          timestamp: 107.162,
        },
      ],
    },
    {
      id: 26,
      words: [
        {
          id: 0,
          text: "(Darkness",
          duration: 0.61,
          timestamp: 107.402,
        },
        {
          id: 1,
          text: "penetrating,",
          duration: 0.61,
          timestamp: 108.022,
        },
        {
          id: 2,
          text: "I'm",
          duration: 0.17,
          timestamp: 108.642,
        },
        {
          id: 3,
          text: "contaminated)",
          duration: 0.52,
          timestamp: 108.822,
        },
      ],
    },
    {
      id: 27,
      words: [
        {
          id: 0,
          text: "All",
          duration: 0.37,
          timestamp: 109.382,
        },
        {
          id: 1,
          text: "the",
          duration: 0.33,
          timestamp: 109.762,
        },
        {
          id: 2,
          text: "things",
          duration: 0.65,
          timestamp: 110.102,
        },
        {
          id: 3,
          text: "that",
          duration: 0.27,
          timestamp: 110.762,
        },
        {
          id: 4,
          text: "I've",
          duration: 0.45,
          timestamp: 111.042,
        },
        {
          id: 5,
          text: "done",
          duration: 0.67,
          timestamp: 111.502,
        },
        {
          id: 6,
          text: "for",
          duration: 0.39,
          timestamp: 112.182,
        },
        {
          id: 7,
          text: "a",
          duration: 0.29,
          timestamp: 112.582,
        },
        {
          id: 8,
          text: "kiss",
          duration: 0.67,
          timestamp: 112.882,
        },
        {
          id: 9,
          text: "from",
          duration: 0.23,
          timestamp: 113.562,
        },
        {
          id: 10,
          text: "the",
          duration: 0.47,
          timestamp: 113.802,
        },
        {
          id: 11,
          text: "sun",
          duration: 0.66,
          timestamp: 114.282,
        },
      ],
    },
    {
      id: 28,
      words: [
        {
          id: 0,
          text: "Tell",
          duration: 0.33,
          timestamp: 114.982,
        },
        {
          id: 1,
          text: "me,",
          duration: 0.31,
          timestamp: 115.322,
        },
        {
          id: 2,
          text: "where",
          duration: 0.41,
          timestamp: 115.642,
        },
        {
          id: 3,
          text: "does",
          duration: 0.31,
          timestamp: 116.062,
        },
        {
          id: 4,
          text: "the",
          duration: 0.37,
          timestamp: 116.382,
        },
        {
          id: 5,
          text: "light",
          duration: 0.65,
          timestamp: 116.762,
        },
        {
          id: 6,
          text: "get",
          duration: 0.77,
          timestamp: 117.422,
        },
        {
          id: 7,
          text: "in?",
          duration: 1.6,
          timestamp: 118.203,
        },
      ],
    },
    {
      id: 29,
      words: [
        {
          id: 0,
          text: "A",
          duration: 1.97,
          timestamp: 120.003,
        },
        {
          id: 1,
          text: "permanent",
          duration: 0.59,
          timestamp: 121.983,
        },
        {
          id: 2,
          text: "eclipse",
          duration: 0.48,
          timestamp: 122.583,
        },
      ],
    },
    {
      id: 30,
      words: [
        {
          id: 0,
          text: "Night",
          duration: 0.19,
          timestamp: 123.403,
        },
        {
          id: 1,
          text: "leaks",
          duration: 0.13,
          timestamp: 123.603,
        },
        {
          id: 2,
          text: "from",
          duration: 0.19,
          timestamp: 123.743,
        },
        {
          id: 3,
          text: "your",
          duration: 0.17,
          timestamp: 123.943,
        },
        {
          id: 4,
          text: "lips",
          duration: 0.34,
          timestamp: 124.123,
        },
      ],
    },
    {
      id: 31,
      words: [
        {
          id: 0,
          text: "I'm",
          duration: 0.15,
          timestamp: 124.643,
        },
        {
          id: 1,
          text: "choking",
          duration: 0.37,
          timestamp: 124.803,
        },
        {
          id: 2,
          text: "in",
          duration: 0.15,
          timestamp: 125.183,
        },
        {
          id: 3,
          text: "a",
          duration: 0.17,
          timestamp: 125.343,
        },
        {
          id: 4,
          text: "lunar",
          duration: 0.69,
          timestamp: 125.523,
        },
        {
          id: 5,
          text: "waterfall",
          duration: 1.08,
          timestamp: 126.223,
        },
      ],
    },
    {
      id: 32,
      words: [
        {
          id: 0,
          text: "Caught",
          duration: 0.23,
          timestamp: 127.603,
        },
        {
          id: 1,
          text: "a",
          duration: 0.11,
          timestamp: 127.843,
        },
        {
          id: 2,
          text: "dying",
          duration: 0.33,
          timestamp: 127.963,
        },
        {
          id: 3,
          text: "kiss",
          duration: 0.48,
          timestamp: 128.303,
        },
      ],
    },
    {
      id: 33,
      words: [
        {
          id: 0,
          text: "Free",
          duration: 0.17,
          timestamp: 129.003,
        },
        {
          id: 1,
          text: "me",
          duration: 0.17,
          timestamp: 129.183,
        },
        {
          id: 2,
          text: "from",
          duration: 0.19,
          timestamp: 129.363,
        },
        {
          id: 3,
          text: "this",
          duration: 0.15,
          timestamp: 129.563,
        },
        {
          id: 4,
          text: "cold",
          duration: 0.35,
          timestamp: 129.723,
        },
        {
          id: 5,
          text: "love",
          duration: 0.36,
          timestamp: 130.083,
        },
      ],
    },
    {
      id: 34,
      words: [
        {
          id: 0,
          text: "Fog",
          duration: 0.39,
          timestamp: 130.763,
        },
        {
          id: 1,
          text: "of",
          duration: 0.48,
          timestamp: 131.163,
        },
        {
          id: 2,
          text: "war",
          duration: 1.2,
          timestamp: 133.203,
        },
      ],
    },
    {
      id: 35,
      words: [
        {
          id: 0,
          text: "I",
          duration: 0.33,
          timestamp: 146.223,
        },
        {
          id: 1,
          text: "made",
          duration: 0.69,
          timestamp: 146.563,
        },
        {
          id: 2,
          text: "my",
          duration: 0.67,
          timestamp: 147.263,
        },
        {
          id: 3,
          text: "home",
          duration: 0.97,
          timestamp: 147.943,
        },
        {
          id: 4,
          text: "in",
          duration: 1.73,
          timestamp: 148.923,
        },
        {
          id: 5,
          text: "hell",
          duration: 1.12,
          timestamp: 150.663,
        },
      ],
    },
    {
      id: 36,
      words: [
        {
          id: 0,
          text: "I",
          duration: 0.31,
          timestamp: 151.843,
        },
        {
          id: 1,
          text: "made",
          duration: 0.71,
          timestamp: 152.163,
        },
        {
          id: 2,
          text: "my",
          duration: 0.67,
          timestamp: 152.883,
        },
        {
          id: 3,
          text: "home",
          duration: 0.75,
          timestamp: 153.563,
        },
        {
          id: 4,
          text: "in",
          duration: 0.27,
          timestamp: 154.323,
        },
        {
          id: 5,
          text: "hell",
          duration: 3,
          timestamp: 154.603,
        },
      ],
    },
    {
      id: 37,
      words: [
        {
          id: 0,
          text: "Where",
          duration: 0.35,
          timestamp: 157.783,
        },
        {
          id: 1,
          text: "does",
          duration: 0.31,
          timestamp: 158.143,
        },
        {
          id: 2,
          text: "the",
          duration: 0.37,
          timestamp: 158.463,
        },
        {
          id: 3,
          text: "light",
          duration: 0.65,
          timestamp: 158.843,
        },
        {
          id: 4,
          text: "get",
          duration: 0.77,
          timestamp: 159.503,
        },
        {
          id: 5,
          text: "in?",
          duration: 0.14,
          timestamp: 160.283,
        },
      ],
    },
    {
      id: 38,
      words: [
        {
          id: 0,
          text: "(Darkness",
          duration: 0.39,
          timestamp: 160.483,
        },
        {
          id: 1,
          text: "penetrating,",
          duration: 0.41,
          timestamp: 160.883,
        },
        {
          id: 2,
          text: "this",
          duration: 0.89,
          timestamp: 161.303,
        },
        {
          id: 3,
          text: "is",
          duration: 0.13,
          timestamp: 162.203,
        },
        {
          id: 4,
          text: "suffocating)",
          duration: 0.98,
          timestamp: 162.343,
        },
      ],
    },
    {
      id: 39,
      words: [
        {
          id: 0,
          text: "Where",
          duration: 0.39,
          timestamp: 163.403,
        },
        {
          id: 1,
          text: "does",
          duration: 0.31,
          timestamp: 163.803,
        },
        {
          id: 2,
          text: "the",
          duration: 0.33,
          timestamp: 164.123,
        },
        {
          id: 3,
          text: "light",
          duration: 0.71,
          timestamp: 164.463,
        },
        {
          id: 4,
          text: "get",
          duration: 0.89,
          timestamp: 165.183,
        },
        {
          id: 5,
          text: "in?",
          duration: 0.1,
          timestamp: 166.084,
        },
      ],
    },
    {
      id: 40,
      words: [
        {
          id: 0,
          text: "(Darkness",
          duration: 0.33,
          timestamp: 166.204,
        },
        {
          id: 1,
          text: "penetrating,",
          duration: 1.13,
          timestamp: 166.544,
        },
        {
          id: 2,
          text: "I'm",
          duration: 0.07,
          timestamp: 167.684,
        },
        {
          id: 3,
          text: "contaminated)",
          duration: 0.54,
          timestamp: 167.764,
        },
      ],
    },
    {
      id: 41,
      words: [
        {
          id: 0,
          text: "All",
          duration: 0.33,
          timestamp: 168.364,
        },
        {
          id: 1,
          text: "the",
          duration: 0.33,
          timestamp: 168.704,
        },
        {
          id: 2,
          text: "things",
          duration: 0.67,
          timestamp: 169.044,
        },
        {
          id: 3,
          text: "that",
          duration: 0.27,
          timestamp: 169.724,
        },
        {
          id: 4,
          text: "I've",
          duration: 0.43,
          timestamp: 170.004,
        },
        {
          id: 5,
          text: "done",
          duration: 0.67,
          timestamp: 170.444,
        },
        {
          id: 6,
          text: "for",
          duration: 0.43,
          timestamp: 171.124,
        },
        {
          id: 7,
          text: "a",
          duration: 0.25,
          timestamp: 171.564,
        },
        {
          id: 8,
          text: "kiss",
          duration: 0.69,
          timestamp: 171.824,
        },
        {
          id: 9,
          text: "from",
          duration: 0.23,
          timestamp: 172.524,
        },
        {
          id: 10,
          text: "the",
          duration: 0.45,
          timestamp: 172.764,
        },
        {
          id: 11,
          text: "sun",
          duration: 0.64,
          timestamp: 173.224,
        },
      ],
    },
    {
      id: 42,
      words: [
        {
          id: 0,
          text: "Tell",
          duration: 0.35,
          timestamp: 173.904,
        },
        {
          id: 1,
          text: "me,",
          duration: 0.31,
          timestamp: 174.264,
        },
        {
          id: 2,
          text: "where",
          duration: 0.39,
          timestamp: 174.584,
        },
        {
          id: 3,
          text: "does",
          duration: 0.31,
          timestamp: 174.984,
        },
        {
          id: 4,
          text: "the",
          duration: 0.39,
          timestamp: 175.304,
        },
        {
          id: 5,
          text: "light",
          duration: 0.65,
          timestamp: 175.704,
        },
        {
          id: 6,
          text: "get",
          duration: 0.83,
          timestamp: 176.364,
        },
        {
          id: 7,
          text: "in?",
          duration: 0.18,
          timestamp: 177.204,
        },
      ],
    },
    {
      id: 43,
      words: [
        {
          id: 0,
          text: "Where",
          duration: 0.35,
          timestamp: 177.444,
        },
        {
          id: 1,
          text: "does",
          duration: 0.37,
          timestamp: 177.804,
        },
        {
          id: 2,
          text: "the",
          duration: 0.19,
          timestamp: 178.184,
        },
        {
          id: 3,
          text: "light",
          duration: 0.81,
          timestamp: 178.384,
        },
        {
          id: 4,
          text: "get",
          duration: 0.12,
          timestamp: 179.204,
        },
        {
          id: 5,
          text: "in?",
          duration: 0.26,
          timestamp: 179.904,
        },
      ],
    },
    {
      id: 44,
      words: [
        {
          id: 0,
          text: "Where",
          duration: 0.41,
          timestamp: 180.224,
        },
        {
          id: 1,
          text: "does",
          duration: 0.37,
          timestamp: 180.644,
        },
        {
          id: 2,
          text: "the",
          duration: 0.27,
          timestamp: 181.024,
        },
        {
          id: 3,
          text: "light",
          duration: 0.65,
          timestamp: 181.304,
        },
        {
          id: 4,
          text: "get",
          duration: 0.79,
          timestamp: 181.964,
        },
        {
          id: 5,
          text: "in?",
          duration: 3,
          timestamp: 182.764,
        },
      ],
    },
  ],
};

export const DEV_RENDER_JOB: TablesInsert<"render_jobs"> = {
  id: "lhj4608ZVs",
  project_id: DEV_PROJECT.id,
  status: "completed",
  composition: KARAOKE_COMPOSITION_NAME,
  render_credits_used: 4,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  download_url:
    "https://renders.mykaraoke.video/hXg3RQXFOFoB/lhj4608ZVs/lhj4608ZVs.mp4",
  settings: {
    crf: 28,
    codec: "h264",
    scale: 0.5,
    extension: "mp4",
  },
  inputProps: {
    // Trimmed for brevity
    lines: [
      {
        id: 0,
        words: [
          { id: 0, text: "This", duration: 0.5, timestamp: 8.2 },
          { id: 1, text: "ain't", duration: 0.22, timestamp: 8.7 },
          { id: 2, text: "a", duration: 0.14, timestamp: 8.92 },
          { id: 3, text: "song", duration: 0.74, timestamp: 9.06 },
          { id: 4, text: "for", duration: 0.28, timestamp: 9.8 },
          { id: 5, text: "the", duration: 0.2, timestamp: 10.08 },
          { id: 6, text: "broken-hearted", duration: 2.1, timestamp: 10.28 },
        ],
      },
    ],
    width: 1920,
    height: 1080,
    layout: { type: "single", animation: "zoom", verticalPosition: "center" },
    bgColor: "linear-gradient(to bottom, #1488cc, #2b32b2)",
    audioSrc:
      "https://media-dev.mykaraoke.video/965bcdda-c2e8-49b6-9e4b-168c370bbbc4/503a55ac-33d0-4e76-aac7-29cd0baabe83/instrumental.mp3",
    isSyncing: false,
    audioMuted: false,
    showLeadIn: false,
    textStyles: [
      {
        fontName: "Tagesschrift",
        fontSize: 80,
        textCase: "none",
        direction: "ltr",
        textColor: "#ffffff",
        wipeColor: "#fab005",
        fontWeight: 900,
        lineSpacing: 1.5,
        outlineColor: "#000000",
        outlineWidth: 12,
        letterSpacing: 0,
      },
      {
        fontName: "Noto Sans",
        fontSize: 80,
        textCase: "none",
        direction: "ltr",
        textColor: "#ffffff",
        wipeColor: "#fab005",
        fontWeight: 900,
        lineSpacing: 1.5,
        outlineColor: "#000000",
        outlineWidth: 12,
        letterSpacing: 0,
      },
      {
        fontName: "Noto Sans",
        fontSize: 80,
        textCase: "none",
        direction: "ltr",
        textColor: "#ffffff",
        wipeColor: "#fab005",
        fontWeight: 900,
        lineSpacing: 1.5,
        outlineColor: "#000000",
        outlineWidth: 12,
        letterSpacing: 0,
      },
    ],
    watermarked: false,
    vocalLeadSrc:
      "https://media-dev.mykaraoke.video/965bcdda-c2e8-49b6-9e4b-168c370bbbc4/503a55ac-33d0-4e76-aac7-29cd0baabe83/lead_vocals.mp3",
    bgMediaAsCover: false,
    vocalBackingSrc:
      "https://media-dev.mykaraoke.video/965bcdda-c2e8-49b6-9e4b-168c370bbbc4/503a55ac-33d0-4e76-aac7-29cd0baabe83/backing_vocals.mp3",
    vocalLeadVolume: 0,
    durationInFrames: 6750,
    vocalAudioVolume: 0,
    vocalBackingVolume: 100,
    showBarOnBreaksLongerThan: null,
    showCountdownOnBreaksLongerThan: 5,
  },
};

/**
 * The pop label the detector reports for each Chord in the dev project, with
 * the spellings it would report alongside it. "N" is a No-Chord Span.
 */
type DevChordLabel = "Cm" | "Ab" | "Eb" | "Bb" | "Fm" | "N";

const DEV_CHORD_SPELLINGS: Record<
  DevChordLabel,
  { majmin: string; jazz: string; nashville: string }
> = {
  Cm: { majmin: "C:min", jazz: "C-", nashville: "1-" },
  Ab: { majmin: "Ab:maj", jazz: "Ab", nashville: "b6" },
  Eb: { majmin: "Eb:maj", jazz: "Eb", nashville: "b3" },
  Bb: { majmin: "Bb:maj", jazz: "Bb", nashville: "b7" },
  Fm: { majmin: "F:min", jazz: "F-", nashville: "4-" },
  N: { majmin: "N", jazz: "N", nashville: "N" },
};

/** One bar of 4/4 at the song's 120 BPM. */
const DEV_CHORD_BAR_SECONDS = 2;

/**
 * The song's sections, each a run of one-bar chords. Written out rather than
 * transcribed from the record: this is dev data, so it only has to be the
 * right shape and a plausible progression — i, VI, III, VII in C minor.
 */
const DEV_CHORD_SECTIONS: DevChordLabel[][] = [
  ["N", "N", "N", "N"], // talk-box intro
  ["Cm", "Ab", "Eb", "Bb"], // intro riff
  ["Cm", "Ab", "Eb", "Bb", "Cm", "Ab", "Eb", "Bb"], // verse 1
  ["Ab", "Bb", "Cm", "Cm"], // pre-chorus
  ["Cm", "Ab", "Eb", "Bb", "Cm", "Ab", "Eb", "Bb"], // chorus 1
  ["N", "N"], // post-chorus break
  ["Cm", "Ab", "Eb", "Bb", "Cm", "Ab", "Eb", "Bb"], // verse 2
  ["Ab", "Bb", "Cm", "Cm"], // pre-chorus
  ["Cm", "Ab", "Eb", "Bb", "Cm", "Ab", "Eb", "Bb"], // chorus 2
  ["N", "N", "N", "N"], // break
  ["Fm", "Ab", "Eb", "Bb", "Fm", "Ab", "Bb", "Bb"], // bridge
  ["Cm", "Ab", "Eb", "Bb", "Cm", "Ab", "Eb", "Bb"], // solo
  ["Ab", "Bb", "Cm", "Cm"], // pre-chorus
  ["Cm", "Ab", "Eb", "Bb", "Cm", "Ab", "Eb", "Bb"], // chorus 3
  ["Cm", "Ab", "Eb", "Bb", "Cm", "Ab", "Eb", "Bb"], // chorus 4
  ["Cm", "Ab", "Eb", "Bb", "Cm", "Ab", "Eb", "Bb"], // outro chorus
  ["Cm", "Cm"], // outro hit
  ["N", "N", "N", "N"], // fade
];

/**
 * Chords for the dev project, shaped like a Music.AI "Transcribe Chords"
 * response — the jazz and Nashville notations and the bar/beat fields
 * included, because that is what the stored payload looks like and what the
 * editor has to carry through untouched when a user corrects one Chord.
 *
 * Runs of the same Chord are merged into a single span, the way a detector
 * reports a change rather than a bar.
 */
export const DEV_PROJECT_CHORDS: TablesInsert<"project_chords"> = {
  id: "b81b4f1e-2a3d-4a0e-9c2f-1d6a7e5b3c04",
  project_id: DEV_PROJECT_ID,
  detected_key: "C minor",
  chords: DEV_CHORD_SECTIONS.flat().reduce<
    Array<Record<string, string | number | null>>
  >((spans, label, bar) => {
    const previous = spans[spans.length - 1];

    // A detector reports a change, not a bar, so a chord held over two bars
    // arrives as one span.
    if (previous && previous.chord_basic_pop === label) {
      previous.end = (bar + 1) * DEV_CHORD_BAR_SECONDS;
      previous.end_bar = bar + 2;
      return spans;
    }

    const { majmin, jazz, nashville } = DEV_CHORD_SPELLINGS[label];

    spans.push({
      start: bar * DEV_CHORD_BAR_SECONDS,
      end: (bar + 1) * DEV_CHORD_BAR_SECONDS,
      start_bar: bar + 1,
      start_beat: 1,
      end_bar: bar + 2,
      end_beat: 1,
      chord_majmin: majmin,
      bass: null,
      bass_nashville: null,
      chord_complex_jazz: jazz,
      chord_simple_jazz: jazz,
      chord_basic_jazz: jazz,
      chord_complex_pop: label,
      chord_simple_pop: label,
      chord_basic_pop: label,
      chord_complex_nashville: nashville,
      chord_simple_nashville: nashville,
      chord_basic_nashville: nashville,
    });

    return spans;
  }, []),
};
